import { getOS } from '@modules/common/utils';
import { OS } from '@modules/common/utils/getOs';
import { Typography, TypographyProps } from '@mui/material';

export const OptionAltHotkeySymbol = (typographyProps: TypographyProps) => {
  const userOS = getOS();

  const symbol = userOS === OS.MAC ? '⌥' : 'Alt';

  return (
    <Typography
      fontSize="body2"
      component="span"
      fontWeight={500}
      {...typographyProps}
    >
      {symbol}
    </Typography>
  );
};
